// Map sizing helpers extracted from channels-location.component.
// Pure functions — no Angular, no state.

declare const google: any;

const WORLD_DIM = { height: 256, width: 256 };
const ZOOM_MAX = 20;

function latRad(lat: number): number {
    const sin = Math.sin((lat * Math.PI) / 180);
    const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
}

function zoomLevel(mapPx: number, worldPx: number, fraction: number): number {
    return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
}

/** Compute the Google-Maps zoom level that fits `bounds` inside `map`'s viewport. */
export function calculateZoomForBounds(map: google.maps.Map, bounds: google.maps.LatLngBounds): number {
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;
    const lngDiff = ne.lng() - sw.lng();
    const lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

    const latZoom = zoomLevel(map.getDiv().clientHeight, WORLD_DIM.height, latFraction);
    const lngZoom = zoomLevel(map.getDiv().clientWidth, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
}

/** True when fewer than this many markers — use a tighter zoom-clamp band. */
const FEW_MARKERS_THRESHOLD = 3;
const FEW_MARKERS_MIN_ZOOM = 5;
const FEW_MARKERS_MAX_ZOOM = 15;
const MANY_MARKERS_MAX_ZOOM = 18;

/** Decide the final zoom for the marker set, clamping to a sane range. */
export function clampZoomForMarkerCount(calculatedZoom: number, markerCount: number): number {
    if (markerCount < FEW_MARKERS_THRESHOLD) {
        return Math.max(FEW_MARKERS_MIN_ZOOM, Math.min(calculatedZoom, FEW_MARKERS_MAX_ZOOM));
    }
    return Math.min(calculatedZoom, MANY_MARKERS_MAX_ZOOM);
}
